export default {
  MsComboboxLoadData: 'comboboxLoadData',
  MsKeydown: 'msKeydown'
};
